import firebase from 'firebase/app';

// Firebase web config
const config = {
  apiKey: 'AIzaSyD_Lqcoa4ShhUbi3vxrLmaGiO_W9mEzzXU',
  authDomain: 'youaresafe-online.firebaseapp.com',
  databaseURL: 'https://youaresafe-online.firebaseio.com',
  projectId: 'youaresafe-online',
  storageBucket: 'youaresafe-online.appspot.com',
  messagingSenderId: '326074484644',
  appId: '1:326074484644:web:5c07a3abf67c5d79436331',
  measurementId: 'G-TPBJ3WPE58',
};

let instance = null;

export default function getFirebase() {
  if (typeof window !== 'undefined') {
    if (instance) return instance;
    instance = firebase.initializeApp(config);
    return instance;
  }

  return null;
}
